var _effectorFileName = "/src/pages/api/teachers/constants.ts";
import { v4 as uuid } from 'uuid';
import type { Teacher } from './types';
export const TEACHERS_LIST: Array<Teacher> = [{
  id: uuid(),
  name: 'teachers.0.name',
  surname: 'teachers.0.surname',
  patronymicName: 'teachers.0.patronymicName',
  img: '/images/teachers/polina.webp',
  facts: ['teachers.0.facts.0', 'teachers.0.facts.1', 'teachers.0.facts.2', 'teachers.0.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.1.name',
  surname: 'teachers.1.surname',
  patronymicName: 'teachers.1.patronymicName',
  img: '/images/teachers/julia.webp',
  facts: ['teachers.1.facts.0', 'teachers.1.facts.1', 'teachers.1.facts.2', 'teachers.1.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.2.name',
  surname: 'teachers.2.surname',
  patronymicName: 'teachers.2.patronymicName',
  img: '/images/teachers/lolita.webp',
  facts: ['teachers.2.facts.0', 'teachers.2.facts.1', 'teachers.2.facts.2', 'teachers.2.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.3.name',
  surname: 'teachers.3.surname',
  patronymicName: 'teachers.3.patronymicName',
  img: '/images/teachers/ian.webp',
  facts: ['teachers.3.facts.0', 'teachers.3.facts.1', 'teachers.3.facts.2', 'teachers.3.facts.3'],
  isVisibleOnPaymentPage: false
}, {
  id: uuid(),
  name: 'teachers.4.name',
  surname: 'teachers.4.surname',
  patronymicName: 'teachers.4.patronymicName',
  img: '/images/teachers/nastya.webp',
  facts: ['teachers.4.facts.0', 'teachers.4.facts.1', 'teachers.4.facts.2', 'teachers.4.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.5.name',
  surname: 'teachers.5.surname',
  patronymicName: 'teachers.5.patronymicName',
  img: '/images/teachers/milya.webp',
  facts: ['teachers.5.facts.0', 'teachers.5.facts.1', 'teachers.5.facts.2', 'teachers.5.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.6.name',
  surname: 'teachers.6.surname',
  patronymicName: 'teachers.6.patronymicName',
  img: '/images/teachers/anna.webp',
  facts: ['teachers.6.facts.0', 'teachers.6.facts.1', 'teachers.6.facts.2', 'teachers.6.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.7.name',
  surname: 'teachers.7.surname',
  patronymicName: 'teachers.7.patronymicName',
  img: '/images/teachers/alika.webp',
  facts: ['teachers.7.facts.0', 'teachers.7.facts.1', 'teachers.7.facts.2', 'teachers.7.facts.3', 'teachers.7.facts.4'],
  isVisibleOnPaymentPage: false
}, {
  id: uuid(),
  name: 'teachers.8.name',
  surname: 'teachers.8.surname',
  patronymicName: 'teachers.8.patronymicName',
  img: '/images/teachers/lera-2.webp',
  facts: ['teachers.8.facts.0', 'teachers.8.facts.1', 'teachers.8.facts.2', 'teachers.8.facts.3', 'teachers.8.facts.4'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.9.name',
  surname: 'teachers.9.surname',
  patronymicName: 'teachers.9.patronymicName',
  img: '/images/teachers/irina.webp',
  facts: ['teachers.9.facts.0', 'teachers.9.facts.1', 'teachers.9.facts.2', 'teachers.9.facts.3'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.10.name',
  surname: 'teachers.10.surname',
  patronymicName: 'teachers.10.patronymicName',
  img: '/images/teachers/albina.webp',
  facts: ['teachers.10.facts.0', 'teachers.10.facts.1', 'teachers.10.facts.2', 'teachers.10.facts.3', 'teachers.10.facts.4'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.11.name',
  surname: 'teachers.11.surname',
  patronymicName: 'teachers.11.patronymicName',
  img: '/images/teachers/danila.webp',
  facts: ['teachers.11.facts.0', 'teachers.11.facts.1', 'teachers.11.facts.2', 'teachers.11.facts.3', 'teachers.11.facts.4'],
  isVisibleOnPaymentPage: true
}, {
  id: uuid(),
  name: 'teachers.12.name',
  surname: 'teachers.12.surname',
  patronymicName: 'teachers.12.patronymicName',
  img: '/images/teachers/mariya-anisimova.webp',
  facts: ['teachers.12.facts.0', 'teachers.12.facts.1', 'teachers.12.facts.2', 'teachers.12.facts.3'],
  isVisibleOnPaymentPage: true
}];